// import $ from 'jquery';
// import _ from 'lodash';
import {
  axiosRemoveCartItem,
  axiosRemoveAllCartItems,
  axiosRequestBackOrderFromServer,
  axiosRequestCartFromServer,
  axiosUpdateCart,
  axiosUpdateCartItemQuantity,
  toggleCartLoading,
  toggleClearCartLoading,
  toggleOnBeforeUnload,
  toggleCartCheckoutButtonLoading,
} from '../actions/cartActions'
import config from '../store/_config'
import { axiosInstance as axios, handleAxiosErrors, isCoreProduct, getSOH, imageBaseUrl } from '_utils'
import { createAlert } from '../dom/window'
// import config from '../store/_config';
import {
  convertCartReportData,
  generateSupplierCartKey,
  getDumbCartForMember,
  getIsCoreValue,
  isAllGoodCartReport,
} from '../selectors/converterSelectors'
import { requestProductsByIDs } from './productsActions'
import { getProductsFullInfo, getCartSupplierCount } from '../selectors/defaultSelectors'
import { requestCart as requestCheckoutCart } from './checkoutSupplierActions'
import { setUserCredentials } from '../actions/userActions'
import { getProductsImage } from '../selectors/productSelectors'
import { addToCartIfCaseAndUnitZero } from './productsSupplierActions'
import { getCoreRange } from '../_utils'

let autoSaveCartTimeout = {}
let autoSaveUpdateCartItemTimeout = {}
let updateCartItemPayload = {}

export const getDisplayImage = (image = '', item = {}) => {
  if (image) {
    if (image.includes(imageBaseUrl)) {
      return image
    } else {
      return imageBaseUrl + image
    }
  } else {
    let defaultImg = getProductsImage(item)
    return defaultImg
  }
}

export const getProcessedDataFromServerResponse = (allResponses, activeCustomer) => {
  let processedResponse = {}

  // Loop through all responses and get the buyableIDs and other information that need to be requested
  allResponses.forEach((response) => {
    let endpointCall
    let isCart = false
    let isBackOrder = false

    if (response?.data?.data?.readOneCart !== undefined) {
      endpointCall = response.data.data.readOneCart
      isCart = true
    } else if (response?.data?.data?.readOneBackOrder !== undefined) {
      endpointCall = response.data.data.readOneBackOrder
      isBackOrder = true
    } else if (response?.data?.data?.addCartOrderItems !== undefined) {
      endpointCall = response.data.data.addCartOrderItems
      isCart = true
    }

    /*
     * Required Fields:
     * ---------------
     * productID
     * case_price
     * unit_price
     * url_slug
     * title
     * qty_per_case
     * sell_by_case
     * caseBackOrder
     * unitBackOrder
     * caseTotal
     * unitTotal
     * caseQty
     * unitQty
     * cartQty
     * backOrderQty
     * cartTotal
     * isCore
     */

    if (endpointCall) {
      endpointCall.Items?.edges?.forEach((orderItem) => {
        const {
          ID: OrderItemID,
          BundleType,
          TotalUnitItems,
          Created,
          Buyable,
          SupplierPromotionDiscount,
          SupplierPromotionType = 0,
          UnitPrice,
          TotalPrice,
          CalculatedSubTotalPrice,
          DisplayImage,
        } = orderItem.node

        const {
          ID: BuyableID,
          InternalItemID,
          WebCategory,
          Title,
          Brand,
          URLSegment,
          SoldAt,
          StockForMelbourne,
          StockForSydney,
          StockForAdelaide,
          StockForBrisbane,
          StockForCairns,
          WholesaleUnitsPerCase,
          ItemsInCase,
          ReSizedDefaultImage,
          SellByPackageOnly,
          IsCoreRange,
        } = Buyable

        const cartKey = generateSupplierCartKey(BuyableID, SupplierPromotionDiscount)
        const isCoreRange = getCoreRange(activeCustomer?.enLocationID, IsCoreRange)
        const sellByCaseOnly = SellByPackageOnly
        const warehouseCode = activeCustomer?.warehouseCode

        let image = getDisplayImage(DisplayImage, Buyable)
        const sohRaw = {
          vic: StockForMelbourne || 0,
          nsw: StockForSydney || 0,
          sa: StockForAdelaide || 0,
          qld: StockForBrisbane || 0,
          wa: StockForCairns || 0,
        }

        //const warehouseCode = window?.warehouseCode
        const isCore = isCoreProduct(warehouseCode, SoldAt)

        if (processedResponse[cartKey] === undefined) {
          processedResponse[cartKey] = {
            // for BE cart manipulation later
            _cartItemID_Case: null,
            _cartItemID_Unit: null,
            _backorderItemID_Case: null,
            _backorderItemID_Unit: null,

            // base
            cartKey: cartKey,
            productID: BuyableID,
            url_slug: URLSegment,
            title: Title,
            sku: InternalItemID,
            wholesale_unit_per_case: WholesaleUnitsPerCase,
            qty_per_case: ItemsInCase,
            sell_by_case: sellByCaseOnly,
            brand: Brand,
            isCore,
            isCoreRange,
            soh: getSOH(isCore, warehouseCode, sohRaw),
            sohRaw,
            image,

            promotionDiscount: SupplierPromotionDiscount,
            promotionType: SupplierPromotionType,

            // will be populated later
            case_price: null,
            unit_price: null,

            caseQty: 0,
            unitQty: 0,
            caseBackOrder: 0,
            unitBackOrder: 0,

            caseTotal: 0,
            unitTotal: 0,

            cartQty: 0,
            backOrderQty: 0,

            // total
            cartTotal: 0,
            backOrderTotal: 0,
          }
        }

        // Setup basic BE keys
        if (isCart) {
          if (BundleType === 'case') {
            processedResponse[cartKey]._cartItemID_Case = OrderItemID
          } else {
            processedResponse[cartKey]._cartItemID_Unit = OrderItemID
          }
        } else if (isBackOrder) {
          if (BundleType === 'case') {
            processedResponse[cartKey]._backorderItemID_Case = OrderItemID
          } else {
            processedResponse[cartKey]._backorderItemID_Unit = OrderItemID
          }
        }

        // Update total
        if (isCart) {
          processedResponse[cartKey].cartTotal += Number(CalculatedSubTotalPrice)
        } else if (isBackOrder) {
          processedResponse[cartKey].backOrderTotal += Number(CalculatedSubTotalPrice)
        }

        if (BundleType === 'case') {
          processedResponse[cartKey].case_price = Number(UnitPrice)
          processedResponse[cartKey].caseTotal += Number(TotalUnitItems)

          if (isCart) {
            processedResponse[cartKey].caseQty += Number(TotalUnitItems)
            processedResponse[cartKey].cartQty += sellByCaseOnly
              ? Number(TotalUnitItems)
              : Number(TotalUnitItems) * ItemsInCase
          } else if (isBackOrder) {
            processedResponse[cartKey].caseBackOrder += Number(TotalUnitItems)
            processedResponse[cartKey].backOrderQty += sellByCaseOnly
              ? Number(TotalUnitItems)
              : Number(TotalUnitItems) * ItemsInCase
          }
        } else {
          processedResponse[cartKey].unit_price = Number(UnitPrice)
          processedResponse[cartKey].unitTotal += Number(TotalUnitItems)

          if (isCart) {
            processedResponse[cartKey].unitQty += Number(TotalUnitItems)
            processedResponse[cartKey].cartQty += Number(TotalUnitItems)
          } else if (isBackOrder) {
            processedResponse[cartKey].unitBackOrder += Number(TotalUnitItems)
            processedResponse[cartKey].backOrderQty += Number(TotalUnitItems)
          }
        }
      })
    } else {
      createAlert({}, 'error')
    }
  })

  return processedResponse
}

export const requestFromServer = () => {
  return (dispatch, getState) => {
    let state = getState()
    const activeCustomer = state.supplier.activeCustomer

    dispatch(toggleCartLoading(true))

    return Promise.all([axiosRequestCartFromServer(), axiosRequestBackOrderFromServer()]).then((allResponses) => {
      const processedResponse = getProcessedDataFromServerResponse(allResponses, activeCustomer)
      const requiredBuyableIDs = Object.keys(processedResponse)

      return Promise.all([dispatch(clearCart())]).then(() => {
        dispatch(updateCartList(processedResponse, activeCustomer.id))
        dispatch(
          setUserCredentials({
            cartItemCount: getCartSupplierCount(processedResponse),
          })
        )
        dispatch(toggleClearCartLoading(false))
        dispatch(toggleCartLoading(false))
      })

      // if(requiredBuyableIDs.length) {
      //
      //     // Now let's request the data
      //     return Promise.all([
      //         dispatch(requestProductsByIDs({
      //             products: requiredBuyableIDs
      //         }))
      //     ]).then(() => {
      //         // Get the final state
      //         state = getState();
      //
      //         const productList = getProductsFullInfo(state.products.list, state);
      //
      //         // Store the promises here
      //         let updateCartItemPromises = [];
      //
      //         Object.values(processedResponse).forEach(item => {
      //             const { BuyableID, CaseQuantity, UnitQuantity, Created } = item;
      //             const productID = BuyableID;
      //             const product = {
      //                 ...productList[productID],
      //                 created: Created,
      //             };
      //
      //             if (product) {
      //                 if (product.sell_by_case) {
      //                     updateCartItemPromises.push(() => dispatch(updateCartItem(product, 'case', Number(CaseQuantity), false, false)));
      //                 } else {
      //                     updateCartItemPromises.push(() => dispatch(updateCartItem(product, 'case', Number(CaseQuantity), false, false)));
      //                     updateCartItemPromises.push(() => dispatch(updateCartItem(product, 'unit', Number(UnitQuantity), false, false)));
      //                 }
      //             } else {
      //                 console.log('Product with ID: ' + productID + ' does not exist');
      //             }
      //         });
      //
      //         // Execute all promises
      //         return Promise.all(updateCartItemPromises.map(promise => promise()));
      //
      //
      //     }).then(() => {
      //         dispatch(toggleCartLoading(false));
      //     });
      // }
      // else {
      //     dispatch(toggleCartLoading(false));
      // }
    })
  }
}

/* Added itemQuantity and isCaseConversion params to handle unit to case conversion on supplier*/
export const getCartDataCaseAndUnit = (cart, itemType, itemQuantity = 0, isCaseConversion = false) => {
  const cartData = []
  Object.entries(cart).map(([key, value]) => {
    const {
      sell_by_case,
      unit_price,
      case_price,
      productID,
      promotionType,
      promotionDiscount,
      caseTotal,
      unitTotal,
    } = value

    if (itemType === 'case') {
      cartData.push({
        BuyableID: productID,
        BundleType: 'case',
        TotalUnitItems: isCaseConversion && itemQuantity > 1 ? itemQuantity : 1,
        SupplierPromotionDiscount: promotionDiscount ? parseFloat(promotionDiscount).toFixed(2) : null,
        SupplierPromotionType: promotionType || null,
        SupplierDiscountedPrice: parseFloat(case_price).toFixed(2),
      })
    }
    if (itemType === 'unit') {
      cartData.push({
        BuyableID: productID,
        BundleType: 'unit',
        TotalUnitItems: 1,
        SupplierPromotionDiscount: promotionDiscount ? parseFloat(promotionDiscount).toFixed(2) : null,
        SupplierPromotionType: promotionType || null,
        SupplierDiscountedPrice: parseFloat(unit_price).toFixed(2),
      })
    }
    // if (!sell_by_case) {
    //   if (caseTotal > 0) {
    //     cartData.push({
    //       BuyableID: productID,
    //       BundleType: 'case',
    //       TotalUnitItems: caseTotal,
    //       SupplierPromotionDiscount: promotionDiscount ? parseFloat(promotionDiscount).toFixed(2) : null,
    //       SupplierPromotionType: promotionType || null,
    //       SupplierDiscountedPrice: parseFloat(case_price).toFixed(2),
    //     })
    //   }

    //   if (unitTotal > 0) {
    //     cartData.push({
    //       BuyableID: productID,
    //       BundleType: 'unit',
    //       TotalUnitItems: unitTotal,
    //       SupplierPromotionDiscount: promotionDiscount ? parseFloat(promotionDiscount).toFixed(2) : null,
    //       SupplierPromotionType: promotionType || null,
    //       SupplierDiscountedPrice: parseFloat(unit_price).toFixed(2),
    //     })

    //   }
    // }
  })
  return cartData
}

export const getCartData = (cart) => {
  const cartData = []
  Object.entries(cart).map(([key, value]) => {
    const {
      sell_by_case,
      unit_price,
      case_price,
      productID,
      promotionType,
      promotionDiscount,
      caseTotal,
      unitTotal,
    } = value

    if (sell_by_case && caseTotal > 0) {
      cartData.push({
        BuyableID: productID,
        BundleType: 'case',
        TotalUnitItems: caseTotal,
        SupplierPromotionDiscount: promotionDiscount ? parseFloat(promotionDiscount).toFixed(2) : null,
        SupplierPromotionType: promotionType || null,
        SupplierDiscountedPrice: parseFloat(case_price).toFixed(2),
      })
    }

    if (!sell_by_case) {
      if (caseTotal > 0) {
        cartData.push({
          BuyableID: productID,
          BundleType: 'case',
          TotalUnitItems: caseTotal,
          SupplierPromotionDiscount: promotionDiscount ? parseFloat(promotionDiscount).toFixed(2) : null,
          SupplierPromotionType: promotionType || null,
          SupplierDiscountedPrice: parseFloat(case_price).toFixed(2),
        })
      }

      if (unitTotal > 0) {
        cartData.push({
          BuyableID: productID,
          BundleType: 'unit',
          TotalUnitItems: unitTotal,
          SupplierPromotionDiscount: promotionDiscount ? parseFloat(promotionDiscount).toFixed(2) : null,
          SupplierPromotionType: promotionType || null,
          SupplierDiscountedPrice: parseFloat(unit_price).toFixed(2),
        })
      }
    }
  })
  return cartData
}
export const processCheckout = () => {
  return (dispatch, getState) => {
    let state = getState()
    const { cartSupplier, supplier } = state
    const customerID = typeof supplier.activeCustomer.id != 'undefined' ? supplier.activeCustomer.id : 0
    const cartList = getDumbCartForMember(cartSupplier.list, customerID)
    const cartData = getCartData(cartList)

    return axiosUpdateCart(cartData)
      .then((response) => {
        // if(isCheckout) {
        //     window.location.href = '/supplier/checkout';
        // }
        // const { status, url, report } = response.data;
        // const finalReport = convertCartReportData(report);
        //
        // if (status && url) {
        //     dispatch(updateCartReport(finalReport));
        //
        //     if(isAllGoodCartReport(finalReport)) {
        //         window.location.href = url;
        //         return;
        //     }
        //     else {
        //         createAlert({
        //             message: 'Some items do not have enough stock, please review your cart.'
        //         }, 'error');
        //     }
        // }
        // else {
        //     createAlert({}, 'error');
        // }
      })
      .catch((error) => handleAxiosErrors(error))
  }
}
export const checkout = () => {
  return (dispatch, getState) => {
    window.location.href = '/supplier/checkout'

    // dispatch(toggleCartLoading(true));
    //
    // Promise.all([
    //     dispatch(processCheckout()),
    // ]).then(() => {
    //     dispatch(toggleCartLoading(false));
    // });
  }
}
export const addRemoteCartItems = (list) => {
  return (dispatch, getState) => {
    const state = getState()
    const cartData = getCartData(list)
    const activeCustomer = state.supplier.activeCustomer

    return axiosUpdateCart(cartData).then((response) => {
      const allResponses = [response]
      const processedResponse = getProcessedDataFromServerResponse(allResponses, activeCustomer)
      const cart = processedResponse
      // TODO: request cart (?)
      const cartItemCount = getCartSupplierCount(processedResponse)

      dispatch(
        setUserCredentials({
          cartItemCount,
        })
      )
    })
  }
}

/* Added isCaseConversion param to handle unit to case conversion on supplier*/
export const addRemoteCartItemsCaseAndUnit = (list, isCaseConversion = false) => {
  return (dispatch, getState) => {
    const state = getState()
    const cartData = getCartDataCaseAndUnit(
      list,
      state?.cartSupplier.selectedItemType,
      state?.cartSupplier.selectedItemQuantity,
      isCaseConversion
    )
    const activeCustomer = state.supplier.activeCustomer
    return axiosUpdateCart(cartData).then((response) => {
      const allResponses = [response]
      const processedResponse = getProcessedDataFromServerResponse(allResponses, activeCustomer)
      const cart = processedResponse
      // TODO: request cart (?)
      const cartItemCount = getCartSupplierCount(processedResponse)

      dispatch(
        setUserCredentials({
          cartItemCount,
        })
      )
    })
  }
}

export const removeCartItem = (cartItem) => {
  return (dispatch, getState) => {
    const state = getState()

    const {
      _cartItemID_Case = null,
      _cartItemID_Unit = null,
      _backorderItemID_Case = null,
      _backorderItemID_Unit = null,
    } = cartItem

    let deletePromises = []

    // Remove Cart
    // -----
    if (_cartItemID_Case) {
      deletePromises.push(axiosRemoveCartItem(_cartItemID_Case))
    }
    if (_cartItemID_Unit) {
      deletePromises.push(axiosRemoveCartItem(_cartItemID_Unit))
    }

    // Remove Backorder
    // -----
    // Supplier has no backorder, so nothing to do here

    // Execute!
    // -----
    dispatch(toggleCartLoading(true))
    return Promise.all(deletePromises).then((response) => {
      dispatch(requestFromServer())
    })

    // ----------------------------

    // const { cartKey } = cartItem;
    // const { cartSupplier, supplier } = state;
    // const customerID = typeof(supplier.activeCustomer.id) != 'undefined' ? supplier.activeCustomer.id : 0;
    //
    // // Modify cart item
    // let modifiedCartItem = {
    //     ...cartItem,
    //     caseTotal: 0,
    //     unitTotal: 0,
    // };
    //
    // // Append to cart list
    // const cartList = {
    //     ...getDumbCartForMember(cartSupplier.list, customerID),
    //     [cartKey]: modifiedCartItem
    // };
    //
    // const cartData = getCartData(cartList);
    //
    // dispatch(toggleCartLoading(true));
    //
    // return axiosUpdateCart(cartData).then((response) => {
    //     dispatch(requestFromServer());
    // });

    // ----------------------------

    // const customerID = typeof(state.supplier.activeCustomer.id) != 'undefined' ? state.supplier.activeCustomer.id : 0;
    //
    // dispatch({
    //     type: 'REMOVE_CART_ITEM_SUPPLIER',
    //     item: item,
    //     user: customerID,
    // });
    //
    // dispatch(adjustCart());
  }
}

export const emptyCartSupplier = (cart) => {
  return (dispatch, getState) => {
    const state = getState()

    dispatch(toggleClearCartLoading(true))

    let deletePromises = []
    let cartItemIDs = []
    if (cart && Object.keys(cart)?.length > 0) {
      // Get all cart item ids
      for (let ele of Object.values(cart)) {
        if (ele?._cartItemID_Case) {
          cartItemIDs.push(ele._cartItemID_Case)
        }

        if (ele?._cartItemID_Unit) {
          cartItemIDs.push(ele._cartItemID_Unit)
        }

        if (ele?._backorderItemID_Case) {
          cartItemIDs.push(ele?._backorderItemID_Case)
        }

        if (ele?._backorderItemID_Unit) {
          cartItemIDs.push(ele?._backorderItemID_Unit)
        }
      }
    }
    console.log('cart ======= emptyCartSupplier', { cart, cartItemIDs })

    if (cartItemIDs?.length > 0) {
      deletePromises.push(axiosRemoveAllCartItems(cartItemIDs))
    }

    // Execute!
    // -----
    return Promise.all(deletePromises).then((response) => {
      dispatch(clearCart())
      dispatch(requestFromServer())
    })
  }
}

export const updateCartList = (list) => {
  return (dispatch, getState) => {
    const state = getState()
    const customerID = typeof state.supplier.activeCustomer.id != 'undefined' ? state.supplier.activeCustomer.id : 0
    dispatch({
      type: 'UPDATE_CART_LIST_SUPPLIER',
      list: list,
      user: customerID,
    })

    // dispatch(adjustCart());
  }
}

export const addUserInput = (cartItem, target, value) => {
  return (dispatch, getState) => {
    const state = getState()
    dispatch(toggleCartLoading(true))
    const { cartKey, productID } = cartItem
    const { supplier, productsSupplier } = state
    const customerID = typeof supplier.activeCustomer.id != 'undefined' ? supplier.activeCustomer.id : 0
    dispatch({
      type: 'UPDATE_CART_ITEM_SUPPLIER',
      product: productsSupplier.list[productID] || {},
      cartItem: cartItem,
      target: target,
      value: value,
      user: customerID,
    })
  }
}

export const updateCartItem = (cartItem, target, value) => {
  return (dispatch, getState) => {
    const state = getState()
    const { cartKey, productID } = cartItem
    const { supplier, productsSupplier } = state
    const customerID = typeof supplier.activeCustomer.id != 'undefined' ? supplier.activeCustomer.id : 0
    /*
      Convert units to cases if units entered are equal to a case to manage subcharges 
    */
    let isUnitConverted = false
    let calculatedCases = 1
    if (target == 'unit' && !cartItem?.sell_by_case && cartItem?.qty_per_case && value / cartItem?.qty_per_case >= 1) {
      let newValue = value % cartItem?.qty_per_case
      calculatedCases = (value - newValue) / cartItem?.qty_per_case || 1
      value = newValue
      isUnitConverted = true
    }
    dispatch(toggleCartCheckoutButtonLoading(true))

    /*
      Update cases qty in cart after converting units to cases
    */
    if (target == 'unit' && isUnitConverted) {
      let totalCases = parseInt(cartItem?.caseTotal || 0)
      if (totalCases == 0) {
        dispatch(addUserInput(cartItem, 'case', totalCases + parseInt(calculatedCases || 0)))
        dispatch(addToCartIfCaseAndUnitZero(cartItem?.productID, true))
      } else {
        dispatch(updateCartItem(cartItem, 'case', totalCases + parseInt(calculatedCases || 0)))
      }
    }

    // Update the details
    dispatch({
      type: 'UPDATE_CART_ITEM_SUPPLIER',
      product: productsSupplier.list[productID] || {},
      cartItem: cartItem,
      target: target,
      value: value,
      user: customerID,
    })

    // Send request to server
    // -------------------------
    // Now check with the server
    // Prepare payload & Execute!
    dispatch(debouncedUpdateCartItem(cartKey, target))
    // -------------------------

    // // Debounce the request
    // // -------------------------
    // // Now check with the server
    // dispatch(debouncedSaveCart());

    // const customerID = typeof(state.supplier.activeCustomer.id) != 'undefined' ? state.supplier.activeCustomer.id : 0;
    //
    // dispatch({
    //     type: 'UPDATE_CART_ITEM_SUPPLIER',
    //     cartItem: cartItem,
    //     target: target,
    //     value: value,
    //     user: customerID,
    // });
    //
    // dispatch(adjustCart());
  }
}
export const debouncedSaveCart = () => {
  return (dispatch, getState) => {
    toggleOnBeforeUnload(true)
    clearTimeout(autoSaveCartTimeout)

    autoSaveCartTimeout = setTimeout(() => {
      const state = getState()

      const { cartSupplier, supplier } = state
      const customerID = typeof supplier.activeCustomer.id != 'undefined' ? supplier.activeCustomer.id : 0

      const cartData = getCartData(getDumbCartForMember(cartSupplier.list, customerID))

      dispatch(toggleCartLoading(true))

      return axiosUpdateCart(cartData)
        .then((response) => {
          return Promise.all([dispatch(requestFromServer())])
        })
        .then(() => {
          toggleOnBeforeUnload(false)

          if (document.getElementById('checkout')) {
            dispatch(requestCheckoutCart())
          }
        })
    }, 1500)
  }
}
export const debouncedUpdateCartItem = (cartKey, bundleType) => {
  return (dispatch, getState) => {
    toggleOnBeforeUnload(true)

    clearTimeout(autoSaveUpdateCartItemTimeout)

    // Store the data
    updateCartItemPayload[`${cartKey}-${bundleType}`] = {
      cartKey,
      bundleType,
    }

    autoSaveUpdateCartItemTimeout = setTimeout(() => {
      dispatch(bulkUpdateCartItemToServer())
    }, 1500)
  }
}
export const bulkUpdateCartItemToServer = () => {
  return (dispatch, getState) => {
    const state = getState()

    const { cartSupplier, supplier } = state
    const customerID = typeof supplier.activeCustomer.id != 'undefined' ? supplier.activeCustomer.id : 0

    const customerCartList = getDumbCartForMember(cartSupplier.list, customerID)

    let updatePromises = []

    Object.values(updateCartItemPayload).forEach((payload) => {
      const { cartKey, bundleType } = payload
      const cartItem = customerCartList[cartKey]
      const { caseTotal = 0, unitTotal = 0, _cartItemID_Case, _cartItemID_Unit } = cartItem

      let cartItemID = null
      let cartItemQty = 0

      if (bundleType === 'case') {
        cartItemID = _cartItemID_Case
        cartItemQty = caseTotal
      } else if (bundleType === 'unit') {
        cartItemID = _cartItemID_Unit
        cartItemQty = unitTotal
      }

      if (cartItemID) {
        updatePromises.push(axiosUpdateCartItemQuantity(cartItemID, cartItemQty))
      }
    })

    toggleOnBeforeUnload(true)

    return Promise.all(updatePromises)
      .then(() => {
        // set payload to null
        updateCartItemPayload = {}

        // request from server
        return Promise.all([dispatch(requestFromServer())])
      })
      .then(() => {
        //if (document.getElementById('checkout')) {
        dispatch(requestCheckoutCart())
        //}
      })
      .catch((error) => {
        handleAxiosErrors(error)
      })
      .then(() => {
        toggleOnBeforeUnload(false)
        dispatch(toggleCartCheckoutButtonLoading(false))
      })
  }
}
export const clearCart = () => {
  return (dispatch, getState) => {
    const state = getState()
    const customerID = typeof state.supplier.activeCustomer.id != 'undefined' ? state.supplier.activeCustomer.id : 0
    dispatch({
      type: 'CLEAR_CART_ITEM_SUPPLIER',
      user: customerID,
    })

    dispatch(adjustCart())
  }
}
export const adjustCart = () => {
  return (dispatch, getState) => {
    const state = getState()
    const customerID = typeof state.supplier.activeCustomer.id != 'undefined' ? state.supplier.activeCustomer.id : 0
    dispatch({
      type: 'ADJUST_CART_ITEM_SUPPLIER',
      user: customerID,
    })
  }
}
export const updateCartReport = (report) => {
  return (dispatch, getState) => {
    const state = getState()
    const customerID = typeof state.supplier.activeCustomer.id != 'undefined' ? state.supplier.activeCustomer.id : 0
    dispatch({
      type: 'UPDATE_CART_REPORT_SUPPLIER',
      user: customerID,
      data: report,
    })
  }
}
